import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-file-list',
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.css']
})
export class FileListComponent  implements OnChanges  {
  
  @Output() fileSelected = new EventEmitter<number>();
  @Input() documentData: any[] = [];
  selectedIndex: any;


  diplayListDocuments:boolean = false;


  files = [
    'Archivo 1.pdf', 'Archivo 2.pdf', 'Archivo 3.pdf', 'Archivo 4.pdf',
    'Archivo 5.pdf', 'Archivo 6.pdf', 'Archivo 7.pdf', 'Archivo 8.pdf'
    // Agrega más archivos según sea necesario
  ];

  itemsPerPage: number = 4; // Número de archivos por página
  currentPage: number = 1; // Página actual
  totalPages: number; // Total de páginas

  get paginatedFiles(): string[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.files.slice(startIndex, startIndex + this.itemsPerPage);
  }

  selectFile(id: number) {
    
    this.fileSelected.emit(id);
    let indexSelected =  this.documentData.findIndex((x:any)=>{
      return x.id ==  id
    });

    if( indexSelected >= 0  ){
      this.selectedIndex = indexSelected;
    }
    
  }

  showDocumentMenu(){
    this.diplayListDocuments = !this.diplayListDocuments;
  }

 nextPage(): void {
  if (this.selectedIndex == null) return;
  if (this.selectedIndex >= this.documentData.length - 1) return; // tope
  this.selectedIndex++;
  const item = this.documentData[this.selectedIndex];
  if (item) this.selectFile(item.id);
}

previousPage(): void {
  if (this.selectedIndex == null) return;
  if (this.selectedIndex <= 0) return; // tope
  this.selectedIndex--;
  const item = this.documentData[this.selectedIndex];
  if (item) this.selectFile(item.id);
}


  ngOnInit() {

    this.calculateTotalPages();
  }

  private calculateTotalPages() {
    this.totalPages = Math.ceil(this.files.length / this.itemsPerPage);
  }

  ngOnChanges(changes: SimpleChanges): void {      
    if(  changes['documentData']  && changes['documentData'].currentValue   ){    
      if( Array.isArray(changes['documentData'].currentValue) &&  changes['documentData'].currentValue.length > 0  ){
        this.selectedIndex =  0;
        this.selectFile(changes['documentData'].currentValue[0]?.id)
      }      
    }    
  }
}
